import { render, staticRenderFns } from "./CellBalance.vue?vue&type=template&id=248c6030"
import script from "./CellBalance.vue?vue&type=script&lang=js"
export * from "./CellBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports